export const dataIdsOfTotalLOA = {
  machines: {
    dataId: 'Total Emissions from stationary fuel combustion',
    scope: 1
  },
  fuel: {dataId: 'Total Emissions from Vehicle fuel combustion', scope: 1},
  refrigerant: {dataId: 'Total Fugitive Emissions', scope: 1},
  electricityNR: {dataId: 'Non-renewable', scope: 2},
  products: {dataId: '', scope: 3},
  investment: {dataId: 'Total holding emissions', scope: 3},
  // assets: {dataId: 'total upstream leased asset emission', scope: 3},
  // supplyChain: {dataId: 'Total upstream and downstream emissions', scope: 3},
  waste: {dataId: 'Total emissions from waste', scope: 3},
  capitalGoods: {
    dataId: 'Total emissions for capital goods Ave Supplier',
    scope: 3
  },
  otherActivities: {
    dataId: 'Fuel And Related Activities',
    scope: 3
  },
  purchasedGoods: {
    dataId:
      'TOTAL EMISSIONS FROM RAW MATERIAL FOR A PARTICULAR FACILITY AVE Supplier',
    scope: 3
  },
  // fuelAndFuelActivities: {dataId: 'Fuel And Related Activities', scope: 3},
  upstreamTransport: {
    dataId: 'Total upstream supply chain emissions',
    scope: 3
  },
  downTransport: {dataId: 'Total downstream supply chain emissions', scope: 3},
  businessTravel: {dataId: 'Total emissions from business travel', scope: 3},
  empCommute: {dataId: 'Total emissions from employee commute', scope: 3},
  upstreamLeased: {dataId: 'total upstream leased asset emission', scope: 3},
  downLeased: {
    dataId: 'Total Downstream leased asset emissions Property and vehicle',
    scope: 3
  },
  processingOfSoldProds: {
    dataId: 'Total emissions from processing of sold Products Average Supplier',
    scope: 3
  },
  useOfSoldProd: {
    dataId: 'Total emissions from use of sold Products',
    scope: 3
  },
  endOfLifeTreatment: {
    dataId: 'total emissions from end of life treatment',
    scope: 3
  },
  franchises: {dataId: 'Total Franchise emissions', scope: 3}
};

export const allCharts = [
  {
    tabLabel: 'All',
    chartType: 'Radial',
    title: 'TOTAL EMISSIONS',
    data: [
      {
        name: 'Products',
        label: 'Products',
        value: 0,
        fill: '#685CEE',
        key: [
          dataIdsOfTotalLOA.products,
          dataIdsOfTotalLOA.purchasedGoods,
          dataIdsOfTotalLOA.processingOfSoldProds,
          dataIdsOfTotalLOA.useOfSoldProd,
          dataIdsOfTotalLOA.endOfLifeTreatment
        ],
        scope: 3
      },
      {
        name: 'Refrigerant',
        label: 'Refrigerant',
        value: 0,
        fill: '#2BD1E9',
        key: [dataIdsOfTotalLOA.refrigerant],
        scope: 1
      },
      {
        name: 'Capital goods',
        label: 'Capital goods',
        value: 0,
        fill: '#FF983F',
        key: [dataIdsOfTotalLOA.capitalGoods],
        scope: 3
      },
      {
        name: 'Other Activities',
        label: 'Other Activitiess',
        value: 0,
        fill: '#78C350',
        key: [dataIdsOfTotalLOA.otherActivities],
        scope: 3
      },
      {
        name: 'Investments',
        label: 'Investments',
        value: 0,
        fill: '#FED766',
        key: [dataIdsOfTotalLOA.investment],
        scope: 3
      },
      {
        name: 'Assets',
        label: 'Assets',
        value: 0,
        fill: '#f74c74',
        key: [dataIdsOfTotalLOA.upstreamLeased],
        scope: 3
      },
      {
        name: 'Supply chain',
        label: 'Supply chain',
        value: 0,
        fill: '#FCA2B5',
        key: [
          dataIdsOfTotalLOA.upstreamTransport,
          dataIdsOfTotalLOA.downTransport
        ],
        scope: 3
      },
      {
        name: 'Waste',
        label: 'Waste',
        value: 0,
        fill: '#FBC9C3',
        key: [dataIdsOfTotalLOA.waste],
        scope: 3
      },
      {
        name: 'Electricity',
        label: 'Electricity',
        value: 0,
        fill: '#98E2CD',
        key: [dataIdsOfTotalLOA.electricityNR],
        scope: 2
      },
      {
        name: 'Fuel',
        label: 'Fuel',
        value: 0,
        fill: '#E0F3D4',
        key: [dataIdsOfTotalLOA.fuel, dataIdsOfTotalLOA.machines],
        scope: 1
      },
      {
        name: 'Others',
        label: 'Others',
        value: 0,
        fill: '#E0F3D4',
        key: [
          dataIdsOfTotalLOA.empCommute,
          dataIdsOfTotalLOA.businessTravel,
          dataIdsOfTotalLOA.franchises,
          dataIdsOfTotalLOA.downLeased
        ],
        scope: 3
      }
    ]
  }
];

export const generalizedLOA = [
  {
    dataId: 'Total GHG Emissions',
    data: [],
    value: 'NA',
    unit: 'tCO2e',
    description: 'Total GHG Emissions',
    image: 'total_ghg_emissions.png',
    fill: '#FF33A1',
    label: 'GHG Emissions by Scope'
  },
  {
    dataId: 'Scope 1 GHG emissions',
    data: [],
    value: 'NA',
    percentage: null,
    unit: 'tCO2e',
    description: 'Scope 1 GHG emissions',
    image: 'scope1_ghg_emissions.png',
    fill: '#78C350',
    label: 'Scope 1'
  },
  {
    dataId: 'Scope 2 GHG emissions',
    data: [],
    value: 'NA',
    percentage: null,
    unit: 'tCO2e',
    description: 'Scope 2 GHG emissions',
    image: 'scope2_ghg_emissions.png',
    fill: '#5BCEAE',
    label: 'Scope 2'
  },
  {
    dataId: 'Scope 3 GHG emissions',
    data: [],
    value: 'NA',
    percentage: null,
    unit: 'tCO2e',
    description: 'Scope 3 GHG emissions',
    image: 'scope3_ghg_emissions.png',
    fill: '#46BBE0',
    label: 'Scope 3'
  }
];

export const scopeMetrics = [
  {
    label: 'Scope 1',
    scopeColor: '#E7E5FC',
    color: '#685CEE',
    data: [
      {
        value: 4,
        label: 'Company Machines',
        background: '#E7E5FC',
        color: '#685CEE',
        key: [dataIdsOfTotalLOA.machines]
      },
      {
        value: 3,
        label: 'Company Vehicles',
        background: '#E7E5FC',
        color: '#685CEE',
        key: [dataIdsOfTotalLOA.fuel]
      },
      {
        value: 5,
        label: 'Refrigerant',
        background: '#E7E5FC',
        color: '#685CEE',
        key: [dataIdsOfTotalLOA.refrigerant]
      }
    ]
  },
  {
    label: 'Scope 2',
    scopeColor: '#E0EFFD',
    color: '#2BD1E9',
    data: [
      {
        value: 1,
        label: 'Electricity',
        key: [dataIdsOfTotalLOA.electricityNR]
      }
    ]
  },
  {
    label: 'Scope 3',
    scopeColor: '#FFF5EB',
    color: '#FF983F',
    data: [
      {
        value: 1,
        label: 'Purchased goods and services',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.purchasedGoods]
      },
      {
        value: 1,
        label: 'Capital Goods',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.capitalGoods]
      },
      {
        value: 1,
        label: 'Fuel and Energy-related activities',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.otherActivities]
      },
      {
        value: 1,
        label: 'Upstream transportation & Distribution',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.upstreamTransport]
      },
      {
        value: 1,
        label: 'Waste generated in operations',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.waste]
      },
      {
        value: 1,
        label: 'Business travel',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.businessTravel]
      },
      {
        value: 1,
        label: 'Employee Commute',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.empCommute]
      },
      {
        value: 1,
        label: 'Upstream leased assets',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.upstreamLeased]
      },
      {
        value: 1,
        label: 'Downstream Transportation & Distribution',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.downTransport]
      },
      {
        value: 1,
        label: 'Processing of sold products',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.processingOfSoldProds]
      },
      {
        value: 1,
        label: 'Use of sold products',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.useOfSoldProd]
      },
      {
        value: 1,
        label: 'End-of-life treatment of sold products',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.endOfLifeTreatment]
      },
      {
        value: 1,
        label: 'Downstream leased assets',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.downLeased]
      },
      {
        value: 1,
        label: 'Franchises',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.franchises]
      },
      {
        value: 1,
        label: 'Investments',
        background: '#FFF5EB',
        color: '#FF983F',
        key: [dataIdsOfTotalLOA.investment]
      }
    ]
  }
];
